import createPermissionsForUser from './access/createPermissionsForUser'
import deletePermissionsForUser from './access/deletePermissionsForUser'
import getAllUserPermissions from './access/getAllUserPermissions'
import getUserPermissions from './access/getUserPermissions'
import updatePermissionsForUser from './access/updatePermissionsForUser'
import acceptAccount from './accounts/acceptAccount'
import rejectAccount from './accounts/rejectAccount'
import editAccount from './accounts/editAccount'
import createNewAccount from './accounts/createNewAccount'
import submitStgFollowUp from './accounts/submitStgFollowUp'
import stgApproveAccount from './accounts/stgApproveAccount'
import stgRejectAccount from './accounts/stgRejectAccount'
import getAccounts from './accounts/getAccounts'
import getSingleAccount from './accounts/getSingleAccount'

import acceptgcpProject from './gcpProjects/acceptgcpProject'
import rejectgcpProject from './gcpProjects/rejectgcpProject'
import editgcpProject from './gcpProjects/editgcpProject'
import createNewgcpProject from './gcpProjects/createNewgcpProject'
import getgcpProjects from './gcpProjects/getgcpProject'
import getSinglegcpProject from './gcpProjects/getSinglegcpProject'
import updateGcpProjectDetails from './gcpProjects/updateDetails'

import acceptProject from './projects/acceptProject'
import createNewProject from './projects/createNewProject'
import editProject from './projects/editProject'
import getProjects from './projects/getProjects'
import getSingleProject from './projects/getSingleProject'
import rejectProject from './projects/rejectProject'

import createTags from './tags/createTags'
import getTagsById from './tags/getTagsById'
import getTagDetails from './tags/getTagDetails'
import modifyTagDetailValue from './tags/modifyTagDetailValue'
import updateTagDetailValue from './tags/updateTagDetailValue'
import updateMultiStepTagsById from './tags/updateMultiStepTagsById'
import approveTagsById from './tags/approveTagsById'
import updateTagsById from './tags/updateTagsById'
import getTagsByAccountId from './tags/getTagsByAccountId'

import getPlatforms from './platforms/getPlatforms'
import getPlatformAliases from './platforms/getPlatformAliases'
import createNewPlatform from './platforms/createNewPlatform'
import editPlatform from './platforms/editPlatform'
import rejectPlatform from './platforms/rejectPlatform'
import acceptPlatform from './platforms/acceptPlatform'
import getSinglePlatform from './platforms/getSinglePlatform'

import getApplications from './applications/getApplication'
import getSingleApplication from './applications/getSingleApplication'
import rejectApplication from './applications/rejectApplication'
import editApplication from './applications/editApplication'
import createNewApplication from './applications/createNewApplication'
import acceptApplication from './applications/acceptApplication'
import getMongoDBRequests from './mongodb/getMongoDBRequests'
import getSingleMongoDB from './mongodb/getSingleMongoDB'
import getMongoDBEligibility from './mongodb/getMongoDBEligibility'
import createNewMongoDB from './mongodb/createNewMongoDB'
import approveMongoDB from './mongodb/approveMongoDB'
import rejectMongoDB from './mongodb/rejectMongoDB'
import reopenMongoDB from './mongodb/reopenMongoDB'
import updateMongoDBDetails from './mongodb/updateMongoDBDetails'

import getRhocpTenants from './rhocpTenants/getRhocpTenants'
import createNewRhocpTenant from './rhocpTenants/createNewRhocpTenant'
import getSingleRhocpTenant from './rhocpTenants/getSingleRhocpTenant'
import acceptRhocpTenant from './rhocpTenants/acceptRhocpTenant'
import rejectRhocpTenant from './rhocpTenants/rejectRhocpTenant'
import editRhocpTenant from './rhocpTenants/editRhocpTenant'
import getTagsByGCPProjectId from './tags/getTagsByGCPProjectId'

import createNewCert from './gcpCerts/createNewCert'
import getSingleCert from './gcpCerts/getSingleCert'
import getCerts from './gcpCerts/getCert'
import getAllCerts from './gcpCerts/getAllCerts'
import approveCert from './gcpCerts/approveCert'
import rejectCert from './gcpCerts/rejectCert'
import reopenCert from './gcpCerts/reopenCert'

import createNewResource from './projects/resources/createNewResource'
import getProjectResources from './projects/resources/getProjectResources'
import getSingleProjectResource from './projects/resources/getSingleProjectResource'
import approveResource from './projects/resources/approveResource'
import rejectResource from './projects/resources/rejectResource'
import getAllProjectResources from './projects/resources/getAllProjectResources'
import getMicroservices from './microservices/getMicroservices'
import createNewMicroservice from './microservices/createNewMicroservice'
import editMicroservice from './microservices/editMicroservice'
import rejectMicroservice from './microservices/rejectMicroservice'
import acceptMicroservice from './microservices/acceptMicroservice'
import getSingleMicroservice from './microservices/getSingleMicroservice'
import getApis from './apis/getApis'
import createNewApi from './apis/createNewApi'
import editApi from './apis/editApi'
import rejectApi from './apis/rejectApi'
import acceptApi from './apis/acceptApi'
import getSingleApi from './apis/getSingleApi'
import updateApprovers from './projects/resources/updateApprovers'
import getClusters from './clusters/getClusters'
import getEksClusterVersions from './clusters/getEksClusterVersions'
import getSingleCluster from './clusters/getSingleCluster'
import createNewCluster from './clusters/createNewCluster'
import acceptCluster from './clusters/acceptCluster'
import rejectCluster from './clusters/rejectCluster'
import updateCertApprovers from './gcpCerts/updateCert'
import updateCertDetails from './gcpCerts/updateCertDetails'
import getAllAdGroups from './active-directory/getAllAdGroups'
import addAdGroupMember from './active-directory/addAdGroupMember'
import getMultiTenantRequests from './multiTenantRequests/getMultiTenantRequests'
import getSingleMultiTenantRequest from './multiTenantRequests/getSingleMultiTenantRequest'
import createMultiTenantRequest from './multiTenantRequests/createMultiTenantRequest'
import acceptMultiTenantRequest from './multiTenantRequests/acceptMultiTenantRequest'
import rejectMultiTenantRequest from './multiTenantRequests/rejectMultiTenantRequest'

const api = {
	projects: {
		getProjects,
		getSingleProject,
		createNewProject,
		rejectProject,
		acceptProject,
		editProject,
		resources: {
			createNewResource,
			getProjectResources,
			getSingleProjectResource,
			getAllProjectResources,
			approveResource,
			rejectResource,
			updateApprovers
		}
	},
	activeDirectory: {
		addAdGroupMember,
		getAllAdGroups
	},
	accessManagement: {
		getUserPermissions,
		getAllUserPermissions,
		createPermissionsForUser,
		updatePermissionsForUser,
		deletePermissionsForUser
	},
	accounts: {
		getAccounts,
		getSingleAccount,
		createNewAccount,
		submitStgFollowUp,
		stgApproveAccount,
		stgRejectAccount,
		acceptAccount,
		rejectAccount,
		editAccount
	},
	tags: {
		getTagsById,
		getTagDetails,
		modifyTagDetailValue,
		updateTagDetailValue,
		createTags,
		updateMultiStepTagsById,
		approveTagsById,
		updateTagsById,
		getTagsByAccountId,
		getTagsByGCPProjectId
	},
	platforms: {
		getPlatforms,
		getPlatformAliases,
		getSinglePlatform,
		createNewPlatform,
		editPlatform,
		acceptPlatform,
		rejectPlatform
	},
	applications: {
		getApplications,
		getSingleApplication,
		createNewApplication,
		editApplication,
		acceptApplication,
		rejectApplication
	},
		gcpProjects: {
			getgcpProjects,
			getSinglegcpProject,
			createNewgcpProject,
			acceptgcpProject,
			rejectgcpProject,
			editgcpProject,
			updateDetails: updateGcpProjectDetails
		},
	gcpCerts: {
		createNewCert,
		getCerts,
		getSingleCert,
		getAllCerts,
		approveCert,
		rejectCert,
		reopenCert,
		updateCertApprovers,
		updateCertDetails
	},
	rhocpTenants: {
		getRhocpTenants,
		getSingleRhocpTenant,
		createNewRhocpTenant,
		acceptRhocpTenant,
		rejectRhocpTenant,
		editRhocpTenant
	},
	microservices: {
		getMicroservices,
		createNewMicroservice,
		getSingleMicroservice,
		acceptMicroservice,
		rejectMicroservice,
		editMicroservice
	},
	apis: {
		getApis,
		createNewApi,
		getSingleApi,
		acceptApi,
		rejectApi,
		editApi
	},
	clusters: {
		getClusters,
		getEksClusterVersions,
		getSingleCluster,
		createNewCluster,
		acceptCluster,
		rejectCluster
	},
	multiTenantRequests: {
		getMultiTenantRequests,
		getSingleMultiTenantRequest,
		createMultiTenantRequest,
		acceptMultiTenantRequest,
		rejectMultiTenantRequest
	},
	mongodb: {
		getMongoDBRequests,
		getSingleMongoDB,
		getMongoDBEligibility,
		createNewMongoDB,
		approveMongoDB,
		rejectMongoDB,
		reopenMongoDB,
		updateMongoDBDetails
	}
}

export default api
